/* eslint-disable max-lines-per-function */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UserQuotaSelectors } from 'reactApp/modules/userQuota/userQuota.selectors';
import { FastCleanSelectors } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.selectors';

export const useFastCleanerModalContent = () => {
    const overquota = useSelector(UserQuotaSelectors.getOverQuota);
    const { messagesRemoveSize, messagesSafeSize } = useSelector(FastCleanSelectors.getMessages);
    const { cloudRemoveSize, cloudSafeSize } = useSelector(FastCleanSelectors.getCloud);

    const hasSafe = useMemo(() => cloudSafeSize + messagesSafeSize > 0, [cloudSafeSize, messagesSafeSize]);
    const hasRemove = useMemo(() => messagesRemoveSize + cloudRemoveSize > 0, [messagesRemoveSize, cloudRemoveSize]);

    const hasFiles = useMemo(() => cloudSafeSize + cloudRemoveSize > 0, [cloudSafeSize, cloudRemoveSize]);
    const hasMessages = useMemo(() => messagesRemoveSize + messagesSafeSize > 0, [messagesRemoveSize, messagesSafeSize]);

    const hasCloudRemove = cloudRemoveSize > 0;
    const hasMessagesRemove = messagesRemoveSize > 0;

    const { description, title, removeFootnote, safeFootnote } = useMemo(() => {
        // удаление файлов и писем + сейфование остального
        if (hasSafe && hasRemove && hasCloudRemove && hasMessagesRemove) {
            return {
                title: 'Удалить письма и файлы из спама и корзины, а остальное положить в сейф?',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>&nbsp;— освободите место, чтобы&nbsp;снять
                        ограничения
                    </>
                ),
                removeFootnote: 'Письма и файлы из спама и корзины удалятся навсегда',
                safeFootnote: 'Остальные попадут в сейф. Это раздел, где письма из Почты и файлы из Облака хранятся, но не занимают место',
            };
        }

        // удаление писем + сейфование остального
        if (hasSafe && hasRemove && hasMessagesRemove) {
            return {
                title: 'Удалить письма из спама и корзины, а остальное положить в сейф?',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>&nbsp;— освободите место, чтобы&nbsp;снять
                        ограничения
                    </>
                ),
                removeFootnote: 'Письма из спама и корзины удалятся навсегда',
                safeFootnote: 'Остальные попадут в сейф. Это раздел, где письма из Почты хранятся, но не занимают место',
            };
        }

        // удаление файлов + сейфование
        if (hasSafe && hasRemove) {
            return {
                title: 'Удалить файлы из корзины, а остальное положить в сейф?',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>&nbsp;— освободите место, чтобы&nbsp;снять
                        ограничения
                    </>
                ),
                removeFootnote: 'Файлы из корзины удалятся навсегда',
                safeFootnote: 'Остальные попадут в сейф. Это раздел, где письма из Почты и файлы из Облака хранятся, но не занимают место',
            };
        }

        // сейфование файлов и писем
        if (hasSafe && hasFiles && hasMessages) {
            return {
                title: 'Положите письма и файлы в сейф — место освободится',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>. Освободите место, чтобы&nbsp;снять ограничения
                    </>
                ),
                removeFootnote: '',
                // eslint-disable-next-line sonarjs/no-duplicate-string
                safeFootnote: 'Сейф — это раздел, где письма из Почты и файлы из Облака хранятся, но не занимают место',
            };
        }

        // сейфование писем
        if (hasSafe && hasMessages) {
            return {
                title: 'Положите письма в сейф — место освободится',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>. Освободите место, чтобы&nbsp;снять ограничения
                    </>
                ),
                removeFootnote: '',
                safeFootnote: 'Сейф — это раздел, где письма из Почты и файлы из Облака хранятся, но не занимают место',
            };
        }

        // сейфование файлов
        if (hasSafe) {
            return {
                title: 'Положите файлы в сейф — место освободится',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>. Освободите место, чтобы&nbsp;снять ограничения
                    </>
                ),
                removeFootnote: '',
                safeFootnote: 'Сейф — это раздел, где письма из Почты и файлы из Облака хранятся, но не занимают место',
            };
        }

        // удаление писем и файлов
        if (hasFiles && hasMessages) {
            return {
                title: 'Удаление писем и файлов',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>&nbsp;— удалите письма и файлы из&nbsp;спама
                        и&nbsp;корзины. Этого&nbsp;хватит, чтобы&nbsp;освободить место и&nbsp;снять ограничения
                    </>
                ),
                removeFootnote: 'Письма и файлы из спама и корзины удалятся навсегда',
                safeFootnote: '',
            };
        }

        // удаление писем
        if (hasMessages) {
            return {
                title: 'Удаление писем',
                description: (
                    <>
                        Пространство переполнено на&nbsp;<span>{overquota.value}</span>&nbsp;— удалите письма из&nbsp;спама и&nbsp;корзины.
                        Этого&nbsp;хватит, чтобы&nbsp;освободить место и&nbsp;снять ограничения
                    </>
                ),
                removeFootnote: 'Письма из спама и корзины удалятся навсегда',
                safeFootnote: '',
            };
        }

        // удаление файлов
        return {
            title: 'Удаление файлов',
            description: (
                <>
                    Пространство переполнено на&nbsp;<span>{overquota.value}</span>&nbsp;— удалите файлы из и&nbsp;корзины.
                    Этого&nbsp;хватит, чтобы&nbsp;освободить место и&nbsp;снять ограничения
                </>
            ),
            removeFootnote: 'Файлы из корзины удалятся навсегда',
            safeFootnote: '',
        };
    }, [hasSafe, hasRemove, hasFiles, hasMessages, hasCloudRemove, hasMessagesRemove, overquota]);

    return { title, description, removeFootnote, safeFootnote };
};
